
import { useEffect, useMemo, useState } from "react";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { IGetSubordinateUnitsViaUnitID, useGetSubordinateUnitsViaID } from "../api/getSubordinateUnitsViaID";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// All your logic is here
export const useSubordinateUnitsTable = ({unitID}: useSubordinateUnitsTableProps) => {
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: []});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetSubordinateUnitsViaUnitID []>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getSubordinateUnitsViaIDQuery = useGetSubordinateUnitsViaID({unitId: unitID});

  const loadingDone = [getSubordinateUnitsViaIDQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getSubordinateUnitsViaIDQuery].filter(({ isError }) => isError ? true : false);
  
  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getSubordinateUnitsViaIDQuery.data ? getSubordinateUnitsViaIDQuery.data : [];

  const columnData = [
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "relName",
      columnDisplayName: "Είδος",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "comments",
      columnDisplayName: "Σχόλιο",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };

  useEffect(() => {
    if (modalEvent.action === "showDetails" && selectedRowsOfTable.length > 0) {
      setSelectedRowsOfTable([]);
      setModalEvent({action: "",selectedRows: []});
      navigate(`/configuration/unitconfiguration/detailspage/${selectedRowsOfTable[0].relName}/unittype/${modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1}/unitid`);
    }
  }, [modalEvent, selectedRowsOfTable, navigate, unitID]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
  }
};

interface useSubordinateUnitsTableProps {
  unitID: number;
}
